import DataSourceAreaStacks from './DataSourceAreaStacks';
import { getStackedChartFns } from './utils';
import { memo } from 'react';
import styled from 'styled-components';

const STROKE_WIDTH = 0;
const HALF_STROKE_WIDTH = 0;

const NoDataMessage = styled.p`
    color: ${({ theme }) => theme.neutral_5};
    text-align: center;
`;

const StackedAreaSparkline = memo(
    ({
        series,
        width,
        height,
        margin = {
            t: HALF_STROKE_WIDTH,
            b: HALF_STROKE_WIDTH,
            l: HALF_STROKE_WIDTH,
            r: HALF_STROKE_WIDTH,
        },
        strokeWidth = STROKE_WIDTH,
    }) => {
        if (!(series && series.length))
            return <NoDataMessage>No data</NoDataMessage>;
        const { x, y0, y1, stackData, keys } = getStackedChartFns({
            series,
            xRange0: margin.l,
            xRange1: width - margin.l + margin.r,
            yRange0: height - (margin.b + margin.t + strokeWidth / 2),
            yRange1: margin.t + strokeWidth / 2,
        });

        return (
            <svg width={width} height={height}>
                <DataSourceAreaStacks
                    keys={keys}
                    stackData={stackData}
                    x={x}
                    y0={y0}
                    y1={y1}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    },
);

export default StackedAreaSparkline;
